      (function(allowedPaths) {
        // Function to get query parameters from the URL
        function getQueryParam(param) {
          var urlParams = new URLSearchParams(window.location.search);
          return urlParams.get(param);
        }
    
        // Store userEmail and eventType in localStorage if they exist in the query params
        function storeDataInLocalStorage() {
          var email = getQueryParam('AVTEmail');
          var eventType = getQueryParam('AVTEventType');
    
          if (email) {
            localStorage.setItem('AVTEmail', email);
            console.log('Stored userEmail:', email);
          }
    
          if (eventType) {
            localStorage.setItem('AVTEventType', eventType);
            console.log('Stored eventType:', eventType);
          }
        }
    
        // Check if the current URL path matches any allowed paths
        function isAllowedPage() {
          var currentPath = window.location.pathname;
          return allowedPaths.some(function(path) {
            return currentPath.includes(path);
          });
        }
    
        // Check if an event has already been tracked for this event type
        function hasEventAlreadyBeenTracked(eventType) {
          return localStorage.getItem('TrackedEvent_' + eventType) === 'true';
        }
    
        // Mark the event type as tracked
        function markEventAsTracked(eventType) {
          localStorage.setItem('TrackedEvent_' + eventType, 'true');
        }
    
        // Remove data from localStorage after tracking
        function clearLocalStorage() {
          localStorage.removeItem('AVTEmail');
          localStorage.removeItem('AVTEventType');
          console.log('Cleared localStorage data.');
        }
    
        // Function to trigger tracking if conditions are met
        function trackUserEvent() {
          var storedEmail = localStorage.getItem('AVTEmail');
          var storedEventType = localStorage.getItem('AVTEventType');
    
          if (storedEmail && storedEventType) {
            console.log('Found localStorage data:', storedEmail, storedEventType);
    
            // Check if this event type has already been tracked
            if (!hasEventAlreadyBeenTracked(storedEventType)) {
              // Dynamically load the tracking script from your WordPress site
              var trackingScript = document.createElement('script');
              trackingScript.src = "https://avtree.com/wp-content/plugins/avtree-tracking/js/avtree-tracking.js"; // Path to your hosted script
              trackingScript.onload = function() {
                // Call the tracking function from the loaded script
                if (window.AVTracking && typeof window.AVTracking.trackEvent === 'function') {
                  // Ensure that the current page is allowed before tracking
                  if (isAllowedPage()) {
                    console.log('Page is allowed. Sending tracking event.');
    
                    window.AVTracking.trackEvent(storedEmail, storedEventType, allowedPaths);
    
                    // Mark the event type as tracked and clear the localStorage
                    markEventAsTracked(storedEventType);
                    clearLocalStorage();
                  } else {
                    console.error('Page is not allowed. Skipping tracking.');
                  }
                } else {
                  console.error('Tracking script or function is not available.');
                }
              };
              document.head.appendChild(trackingScript);
            } else {
              console.log('Tracking event for this event type has already been sent. Skipping tracking.');
            }
          } else {
            console.log('No localStorage data to track.');
          }
        }
    
        // Store data in localStorage if query params exist
        storeDataInLocalStorage();
    
        // Check if we can send the tracking event on page load or URL change
        trackUserEvent();
    
        // Listen for URL changes in Single Page Applications (SPA)
        function listenForUrlChanges() {
          var originalPushState = history.pushState;
          var originalReplaceState = history.replaceState;
    
          // Overwrite history.pushState and history.replaceState to detect URL changes
          history.pushState = function() {
            originalPushState.apply(history, arguments);
            trackUserEvent();
          };
    
          history.replaceState = function() {
            originalReplaceState.apply(history, arguments);
            trackUserEvent();
          };
    
          // Also listen to the popstate event (triggered on back/forward navigation)
          window.addEventListener('popstate', function() {
            trackUserEvent();
          });
        }
    
        // Listen for URL changes in SPAs
        listenForUrlChanges();
    
      })(["/thank-you", "/account"]); // Pass the allowed paths as parameter